import axios from 'axios'
import router from '@/router'

import { Notify } from 'vant'
import { getToken } from '@/utils/auth'

import store from '@/store'
import requesturl from '@/utils/requesturl'

// create an axios instance
export const request = axios.create({
  // baseURL: 'http://ms.cdjkyl.com/', // 线上
  // baseURL: 'https://wjcourt.smilou.com', // 测试
  baseURL: requesturl.baseURL,

  // baseURL: 'http://192.168.0.108:9102', // 本地
  timeout: 5000 // request timeout
})
// request 添加请求拦截器
request.interceptors.request.use(
  config => {
    // // //拦截增加商户号
    const orgCode = 'G001'
    if (config.params) {
      config.params['orgCode'] = orgCode
    } else {
      config.params = {
        orgCode
      }
    }
    if (store.getters.token) {
      config.headers['Authorization'] = getToken()
    }

    return config
  },
  error => {
    // do something with request error
    return Promise.reject(error)
  }
)

// response 添加响应拦截器
request.interceptors.response.use(
  /**
     * If you want to get http information such as headers or status
     * Please return  response => response
     */

  /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
  response => {
    const res = response.data

    // if the custom code is not 20000, it is judged as an error.
    if (res.code != 200) {
      Notify({
        message: res.message || '加载失败',
        type: 'danger',
        duration: 5 * 1000
      })
      if (res.code == 401) {
        store.dispatch('user/resetToken')
        router.replace({
          path: '/defLogin'
        })
      }
      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
        // to re-login
        MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
          confirmButtonText: 'Re-Login',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {

        })
      }
      return Promise.reject(new Error(res.message || '加载失败'))
    } else {
      return res
    }
  },
  error => {
    Notify({
      message: error || '加载失败',
      type: 'danger',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export const tinyService = axios.create({

  // baseURL: 'https://plapi.cdjkyl.com', // 线上
  // baseURL:'http://devms.cdjkyl.com/', // 测试
  baseURL: requesturl.baseURL,
  timeout: 5000 // request timeout
})
// request 添加请求拦截器
tinyService.interceptors.request.use(
  config => {
    // // //拦截增加商户号
    // let orgCode = 'O0011'
    // if (config.params){
    //     config.params['orgCode'] =orgCode
    //
    // } else {
    //     config.params={
    //         orgCode
    //     }
    // }

    return config
  },
  error => {
    // do something with request error
    return Promise.reject(error)
  }
)

// response 添加响应拦截器
tinyService.interceptors.response.use(
  /**
     * If you want to get http information such as headers or status
     * Please return  response => response
     */

  /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
  response => {
    const res = response.data

    // if the custom code is not 20000, it is judged as an error.
    if (res.code != 200) {
      Notify({
        message: res.message || '加载失败',
        type: 'danger',
        duration: 5 * 1000
      })
      if (res.code == 401) {
        store.dispatch('user/resetToken')
        router.replace({
          path: '/defLogin'
        })
      }
      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
        // to re-login
        MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
          confirmButtonText: 'Re-Login',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {

        })
      }
      return Promise.reject(new Error('加载失败'))
    } else {
      return res
    }
  },
  error => {
    Notify({
      message: '加载失败',
      type: 'danger',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

